import { render, staticRenderFns } from "./recruitCen.vue?vue&type=template&id=ca213b84&scoped=true&"
import script from "./recruitCen.vue?vue&type=script&lang=js&"
export * from "./recruitCen.vue?vue&type=script&lang=js&"
import style1 from "./recruitCen.vue?vue&type=style&index=1&id=ca213b84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca213b84",
  null
  
)

export default component.exports